var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect4, _rect5, _path12, _path13, _rect6, _rect7, _path14, _rect8, _rect9, _path15, _rect0, _path16, _rect1, _path17, _path18, _path19, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrozen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f-sun",
    cx: "74%",
    cy: "58%",
    r: "18%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc66",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ff9933",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a2a3a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f-sky",
    cx: "50%",
    cy: "0%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#1a2e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203040"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f-aurora",
    cx: "50%",
    cy: "30%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ffe0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#00aa80",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d1c2e",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#f-sky)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#f-aurora)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#f-sun)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,300 Q200,280 400,310 Q600,340 800,300 Q1000,260 1200,290 Q1400,320 1600,300 L1600,0 L0,0 Z",
    fill: "#0d1c2e",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-20,320 Q40,310 90,325 Q140,338 180,310",
    stroke: "#00ffe0",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200,290 Q280,275 360,295 Q440,312 520,285 Q600,258 680,280",
    stroke: "#00ddcc",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M700,275 Q780,258 860,278 Q940,298 1020,272 Q1100,248 1180,268",
    stroke: "#00ffcc",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1300,280 Q1380,265 1460,282 Q1530,298 1600,280",
    stroke: "#00eecc",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.12
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180,
    cy: 530,
    rx: 140,
    ry: 18,
    fill: "#ffcc66",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180,
    cy: 530,
    rx: 80,
    ry: 10,
    fill: "#ffee99",
    opacity: 0.22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,580 Q200,550 400,565 Q600,578 800,550 Q1000,522 1200,545 Q1400,568 1600,545 L1600,900 L0,900 Z",
    fill: "#1a3040",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,620 Q100,600 200,615 Q300,628 400,605 Q500,582 600,608 Q700,632 800,605 Q900,578 1000,602 Q1100,625 1200,600 Q1300,574 1400,600 Q1500,624 1600,600 L1600,900 L0,900 Z",
    fill: "#b8d8e8",
    opacity: 0.85
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,638 Q120,618 240,632 Q360,645 480,622 Q600,598 720,622 Q840,646 960,620 Q1080,594 1200,618 Q1320,642 1440,618 Q1530,600 1600,618 L1600,900 L0,900 Z",
    fill: "#d0eaf5",
    opacity: 0.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,680 Q80,660 160,675 Q240,690 320,668 Q400,645 480,670 Q560,695 640,672 Q720,648 800,672 Q880,696 960,670 Q1040,645 1120,668 Q1200,691 1280,668 Q1360,645 1440,668 Q1520,690 1600,670 L1600,900 L0,900 Z",
    fill: "#e8f4fa",
    opacity: 0.85
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0,720 Q100,700 200,718 Q300,735 400,712 Q500,689 600,714 Q700,739 800,712 Q900,685 1000,710 Q1100,735 1200,710 Q1300,685 1400,710 Q1500,735 1600,712 L1600,900 L0,900 Z",
    fill: "#f0f7fc",
    opacity: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0,760 Q200,740 400,760 Q600,780 800,755 Q1000,730 1200,755 Q1400,780 1600,755 L1600,900 L0,900 Z",
    fill: "#e0eff8",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1130,638 Q1145,550 1160,480 Q1170,430 1180,390",
    stroke: "#8ab0c0",
    strokeWidth: 14,
    fill: "none",
    opacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1160,638 Q1172,545 1185,475 Q1194,425 1202,380",
    stroke: "#8ab0c0",
    strokeWidth: 10,
    fill: "none",
    opacity: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 520,
    width: 80,
    height: 120,
    rx: 4,
    fill: "#6a8898",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 380,
    width: 36,
    height: 160,
    rx: 3,
    fill: "#7a9aaa",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M400,640 Q412,560 420,490 Q428,430 438,380",
    stroke: "#8ab0c0",
    strokeWidth: 18,
    fill: "none",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M430,640 Q440,555 450,480 Q458,420 466,360",
    stroke: "#8ab0c0",
    strokeWidth: 12,
    fill: "none",
    opacity: 0.22
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 480,
    width: 90,
    height: 160,
    rx: 4,
    fill: "#6a8898",
    opacity: 0.35
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 360,
    width: 32,
    height: 130,
    rx: 3,
    fill: "#7a9aaa",
    opacity: 0.45
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M700,642 Q710,570 716,510 Q722,455 730,410",
    stroke: "#8ab0c0",
    strokeWidth: 12,
    fill: "none",
    opacity: 0.28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 684,
    y: 500,
    width: 60,
    height: 142,
    rx: 3,
    fill: "#6a8898",
    opacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 410,
    width: 24,
    height: 100,
    rx: 3,
    fill: "#7a9aaa",
    opacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1350,642 Q1360,575 1368,520 Q1374,472 1382,432",
    stroke: "#8ab0c0",
    strokeWidth: 10,
    fill: "none",
    opacity: 0.25
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1336,
    y: 520,
    width: 56,
    height: 122,
    rx: 3,
    fill: "#6a8898",
    opacity: 0.28
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180,644 Q186,590 190,548 Q195,510 202,475",
    stroke: "#8ab0c0",
    strokeWidth: 9,
    fill: "none",
    opacity: 0.22
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 548,
    width: 48,
    height: 96,
    rx: 3,
    fill: "#6a8898",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0,680 Q200,665 400,678 Q600,690 800,668 Q1000,646 1200,668 Q1400,690 1600,668 L1600,720 Q1400,738 1200,715 Q1000,692 800,715 Q600,738 400,715 Q200,692 0,715 Z",
    fill: "#c8e0f0",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0,730 Q200,715 400,728 Q600,742 800,718 Q1000,694 1200,718 Q1400,742 1600,718 L1600,750 Q1400,766 1200,742 Q1000,718 800,742 Q600,766 400,742 Q200,718 0,742 Z",
    fill: "#d8eaf8",
    opacity: 0.18
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0,780 Q400,762 800,780 Q1200,798 1600,780 L1600,800 Q1200,815 800,798 Q400,780 0,798 Z",
    fill: "#e0f0fa",
    opacity: 0.14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 380,
    height: 900,
    fill: "#0a1620",
    opacity: 0.38
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 900,
    fill: "#08121a",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozen);
export default __webpack_public_path__ + "static/media/frozen.230d0e43011c4ef3b26e6dc034c6312c.svg";
export { ForwardRef as ReactComponent };